import { Image as SliderImage } from '@cian/slider';
import { Image as UIKitImage } from '@cian/ui-kit';

import { type FC } from 'react';

type SlideImageProps = {
  alt?: string;
  isDeoptimised: boolean;
  src: string;
};

/**
 * @description тут определяем, если не пустая строка, то используем Image из слайдера, так как Image из
 *   ui-kit очень сильно тормозит выдачу, а вот если у нас пришла заглушка, то нужно уже показать Image из
 *   ui-kit, так как там есть заглушка под фото
 */
export const SlideImage: FC<SlideImageProps> = props => {
  const { alt = 'Ошибка загрузки фото', isDeoptimised, src } = props;

  if (src) {
    return (
      <SliderImage
        alt={alt}
        decoding={isDeoptimised ? undefined : 'async'}
        loading={isDeoptimised ? undefined : 'lazy'}
        objectFit="cover"
        src={src}
      />
    );
  } else {
    return <UIKitImage alt={alt} src="" />;
  }
};
